import Column from './Column.vue'

export default Column
